module.exports = __webpack_public_path__ + "static/img/til130.788156d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til130.png
// module id = 8kYw
// module chunks = 1